import styled from "styled-components";

//LINK SIDEBAR
export const LinkList = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  ${(props) =>
    props.open === true
      ? "border-right:none"
      : //   : "border-right: 1px solid var(--main-color)"};
        "border-right: none"};
  gap: 2%;

  font-size: 18px;

  &:last-child {
    bottom: 10px;
  }
  div {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: clamp(10px, 20px, 20%);
  }
  .settings {
    margin-top: 50px;
  }
  .settings > hr {
    border: 1px solid var(--text-secondary);
    opacity: 0.4;
  }
  .settings > a {
    background: transparent;
    border-radius: 5px;
    color: var(--text-secondary);
    position: relative;

    &:hover {
      background-color: transparent;
    }

    svg {
      color: var(--text-secondary);
    }

    &.active,
    &:hover,
    &.active > svg,
    &:hover > svg,
    &.active:hover > svg {
      color: var(--main-color);
      cursor: pointer;
    }

    &.active:before {
      background: var(--main-color);
      width: 6px;
      height: 6px;
      content: "";
      position: absolute;
      left: -3px;
      bottom: 44%;
      border-radius: 50%;
    }
  }
  .active {
    background: var(--main-color);
    border-radius: 5px;
    color: white;
    position: relative;
  }
  .active:hover {
    background: var(--main-color);
    svg {
      color: var(--text-primary);
    }
  }
  .active:before {
    background: white;
    width: 6px;
    height: 40px;
    content: "";
    position: absolute;
    left: 0;
    border-radius: 4px;
  }
  a {
    gap: 20px;
    display: flex;
    ${(props) =>
      props.isdesktop === "true"
        ? " padding: 10px 50px 10px 10px"
        : "padding: 15px"};
    text-transform: none;
    align-items: center;
    color: var(--text-secondary);
    svg {
      width: 30px;
      height: 30px;
    }
  }
  a:hover {
    background: var(--bkg-quaternary);
    border-radius: 5px;
    color: white;
    position: relative;
    svg {
      color: var(--text-primary);
    }
  }
  a svg.active {
    color: var(--main-color);
  }
`;

export const Logout = styled.button`
  background: var(--bkg-quaternary);
  border: none;
  border-radius: 4px;
  margin-top: clamp(5px, 1.5rem, 8%);
  font-size: 18px;
  gap: 12px;
  display: flex;
  justify-content: center;
  padding: 7px;
  align-items: center;
  color: var(--text-primary);
  width: 100%;

  svg {
    width: 30px;
    height: 30px;
    color: var(--text-primary);
  }

  &:hover,
  &:hover svg {
    cursor: pointer;
    color: var(--main-color);
  }
`;

//SIDEBAR INTERNAL
export const SideBarInternal = styled.div`
  width: 100%;
  min-width: fit-content;
  height: 100vh;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  gap: 20px;
  padding: 15px;
`;

export const SideBarInternalList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  font-size: 25px;
`;

export const HelpComponent = styled.div`
  width: 280px;
  height: 100%;
  border-radius: 8px;
  background: var(--bkg-tertiary);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  font-size: 18px;
  color: var(--text-primary);
  padding: 12px;
  h3 {
    font-size: 18px;
    font-weight: 500;
  }
  hr {
    border: 1px solid var(--text-secondary);
    opacity: 0.4;
  }
  p {
    margin-top: 30px;
    color: var(--text-secondary);
    font-size: 14px;
    a {
      text-decoration: underline;
      color: var(--text-secondary);
    }
  }
`;
export const UserNameWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 25px 0;
  width: 100%;
  gap: 3px;
  justify-content: center;
`;

export const NameContainer = styled.p`
  color: var(--text-secondary);
`;

export const EmailContainer = styled.h6`
  font-size: 12px;
  color: var(--text-secondary);
`;
const LogoDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  background-color: transparent;
  height: auto;
  width: 180px;
  & img {
    width: 100%;
    height: auto;
  }
`;

export const LogoWrapper = ({ logoImage }) => {
  return (
    <LogoDiv>
      <img src={logoImage} alt="logo" />
    </LogoDiv>
  );
};
